import { NodeType } from '../../types';

export const nodesForExclusion = new Set([
  NodeType.begin,
  NodeType.exit,
  NodeType.note
]);
